import { render } from "./TheHome.vue?vue&type=template&id=2325dc88&scoped=true"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=2325dc88&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2325dc88"]])

export default __exports__